// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".body-textarea textarea{height:260px}", "",{"version":3,"sources":["webpack://./src/client/features/setting_group/ng_applicant_add_dialog/ng_applicant_add_dialog.vue"],"names":[],"mappings":"AAEE,wBACE,YAAA","sourcesContent":["\n.body-textarea {\n  textarea {\n    height: 260px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
